import {ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {BehaviorSubject} from 'rxjs';
import {AsyncPipe} from '@angular/common';

import {GetAllRolesAction} from './../../core/store/roles/roles.action';
import {selectAllRoles} from './../../core/store/roles/roles.selector';
import {TitleService} from './../../core/page/title.service';
import {RolesTableComponent} from '../roles-table/roles-table.component';
import {RolesHeaderComponent} from '../roles-header/roles-header.component';
import {OphLoadingModule} from '../../shared/design/oph-loading/oph-loading.module';

@Component({
  selector: 'roles-main',
  standalone: true,
  imports: [RolesHeaderComponent, AsyncPipe, RolesTableComponent, OphLoadingModule],
  templateUrl: './roles-main.component.html',
  styleUrl: './roles-main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RolesMainComponent implements OnInit, OnDestroy {
  private store$ = inject(Store);
  private titleService = inject(TitleService);

  allRoles$ = this.store$.select(selectAllRoles);
  searchValue$ = new BehaviorSubject<string>('');

  ngOnInit(): void {
    this.titleService.setPageTitle('Roles');
    this.store$.dispatch(new GetAllRolesAction({}));
  }

  ngOnDestroy(): void {
    this.searchValue$.complete();
  }
}
